import gql from 'graphql-tag';

export default gql`
    mutation updateDriver($input: UpdateDriverInput) {
        updateDriver(input: $input) {
            errors
        }
    }
`;
